import type { Template } from "@/types";

export const PO_06_H2_V4: Template[] = [
    {
        id: "po-06-h2v4-01",
        name: "PO 01 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 46, y: 207, width: 248, height: 370, rotation: 0, imageRotation: 0 },
            { id: "2", x: 302, y: 207, width: 272, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 302, y: 395, width: 272, height: 182, rotation: 0, imageRotation: 0 },
            { id: "4", x: 673, y: 150, width: 348, height: 483, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1029, y: 150, width: 172, height: 238, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1029, y: 395, width: 172, height: 238, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-02",
        name: "PO 02 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 138, y: 150, width: 352, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 685, y: 150, width: 377, height: 238, rotation: 0, imageRotation: 0 },
            { id: "3", x: 685, y: 396, width: 377, height: 238, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1070, y: 150, width: 114, height: 156, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1070, y: 314, width: 114, height: 156, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1070, y: 477, width: 114, height: 156, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-03",
        name: "PO 03 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 49, y: 207, width: 261, height: 370, rotation: 0, imageRotation: 0 },
            { id: "2", x: 317, y: 207, width: 261, height: 182, rotation: 0, imageRotation: 0 },
            { id: "3", x: 317, y: 396, width: 261, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 736, y: 207, width: 268, height: 370, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1011, y: 207, width: 130, height: 182, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1011, y: 396, width: 130, height: 181, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-04",
        name: "PO 04 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_04.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 68, y: 86, width: 520, height: 321, rotation: 0, imageRotation: 0 },
            { id: "2", x: 68, y: 415, width: 520, height: 320, rotation: 0, imageRotation: 0 },
            { id: "3", x: 724, y: 86, width: 256, height: 321, rotation: 0, imageRotation: 0 },
            { id: "4", x: 724, y: 415, width: 256, height: 320, rotation: 0, imageRotation: 0 },
            { id: "5", x: 988, y: 86, width: 256, height: 321, rotation: 0, imageRotation: 0 },
            { id: "6", x: 988, y: 415, width: 256, height: 320, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-05",
        name: "PO 05 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 65, y: 82, width: 245, height: 306, rotation: 0, imageRotation: 0 },
            { id: "2", x: 317, y: 82, width: 245, height: 306, rotation: 0, imageRotation: 0 },
            { id: "3", x: 65, y: 395, width: 498, height: 306, rotation: 0, imageRotation: 0 },
            { id: "4", x: 691, y: 82, width: 497, height: 306, rotation: 0, imageRotation: 0 },
            { id: "5", x: 691, y: 395, width: 245, height: 306, rotation: 0, imageRotation: 0 },
            { id: "6", x: 943, y: 395, width: 244, height: 306, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-06",
        name: "PO 06 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 51, y: 146, width: 523, height: 311, rotation: 0, imageRotation: 0 },
            { id: "2", x: 51, y: 464, width: 126, height: 174, rotation: 0, imageRotation: 0 },
            { id: "3", x: 184, y: 464, width: 126, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 317, y: 464, width: 125, height: 174, rotation: 0, imageRotation: 0 },
            { id: "5", x: 449, y: 464, width: 125, height: 174, rotation: 0, imageRotation: 0 },
            { id: "6", x: 675, y: 225, width: 528, height: 334, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-07",
        name: "PO 07 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_07.png",
        size: [1311, 820],
        style: {},
        slots: [      
            { id: "2", x: 54, y: 152, width: 178, height: 255, rotation: 0, imageRotation: 0 },
            { id: "2", x: 54, y: 415, width: 178, height: 254, rotation: 0, imageRotation: 0 },
            { id: "3", x: 240, y: 415, width: 178, height: 254, rotation: 0, imageRotation: 0 },
            { id: "4", x: 426, y: 415, width: 177, height: 254, rotation: 0, imageRotation: 0 },
            { id: "5", x: 240, y: 152, width: 363, height: 255, rotation: 0, imageRotation: 0 },
            { id: "6", x: 707, y: 236, width: 553, height: 350, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h2v4-08",
        name: "PO 08 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 626, height: 783, rotation: 0, imageRotation: 0 },
            { id: "2", x: 693, y: 152, width: 368, height: 236, rotation: 0, imageRotation: 0 },
            { id: "3", x: 693, y: 395, width: 368, height: 236, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1068, y: 152, width: 110, height: 156, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1068, y: 315, width: 110, height: 155, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1068, y: 476, width: 110, height: 155, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-09",
        name: "PO 09 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 51, y: 250, width: 108, height: 138, rotation: 0, imageRotation: 0 },
            { id: "2", x: 51, y: 395, width: 108, height: 138, rotation: 0, imageRotation: 0 },
            { id: "3", x: 167, y: 250, width: 108, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 167, y: 395, width: 108, height: 138, rotation: 0, imageRotation: 0 },
            { id: "5", x: 282, y: 250, width: 457, height: 284, rotation: 0, imageRotation: 0 },
            { id: "6", x: 746, y: 250, width: 457, height: 284, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-10",
        name: "PO 10 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 212, width: 497, height: 359, rotation: 0, imageRotation: 0 },
            { id: "2", x: 504, y: 212, width: 118, height: 176, rotation: 0, imageRotation: 0 },
            { id: "3", x: 504, y: 395, width: 118, height: 176, rotation: 0, imageRotation: 0 },
            { id: "4", x: 630, y: 212, width: 118, height: 176, rotation: 0, imageRotation: 0 },
            { id: "5", x: 630, y: 395, width: 118, height: 176, rotation: 0, imageRotation: 0 },
            { id: "6", x: 755, y: 212, width: 497, height: 359, rotation: 0, imageRotation: 0 }
        ],
    }
];